import { pushUrl, createEl } from "./utils.js";
import home from "./home.js";
import snackbar from "./snackbar.js";
import login from "./login.js";

const [el, refs] = createEl()

function render() {
    const url = new URL(window.location.href);
    refs.page.innerHTML = "";
    if("/" === url.pathname) {
        refs.page.append(home());
    } else if("/login" === url.pathname) {
        refs.page.append(login());
    } else {
        window.location.href = "/";
    }
}

document.body.append(el("div", { ref: "page", class: "page" }));
document.body.append(snackbar.root);

window.addEventListener("load", render);
window.addEventListener("popstate", render);

document.addEventListener("click", (event) => {
    if(event.target.dataset["to"] === "spa") {
        event.preventDefault();
        pushUrl(event.target.href);
    }
});


